import { render, staticRenderFns } from "./UserSectionTemplate.vue?vue&type=template&id=6ec0f072&scoped=true"
import script from "./UserSectionTemplate.vue?vue&type=script&lang=js"
export * from "./UserSectionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0f072",
  null
  
)

export default component.exports